import { render, staticRenderFns } from "./SecondaryNavItem.vue?vue&type=template&id=af80edaa&scoped=true&"
import script from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryNavItem.vue?vue&type=style&index=0&id=af80edaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af80edaa",
  null
  
)

export default component.exports